module.exports = __webpack_public_path__ + "img/visa.5723de79.svg";